export function runWhenActivated(
  document: Pick<
    Document,
    'prerendering' | 'addEventListener' | 'removeEventListener'
  >,
  callback: () => void,
): (() => void) | undefined {
  if (!document.prerendering) {
    callback()
    return
  }

  document.addEventListener('prerenderingchange', callback, { once: true })
  return () => document.removeEventListener('prerenderingchange', callback)
}
